export default {
  methods: {
    /****************************/
    /** Form Validations **/
    /****************************/

    // Form validation
    validateForm(formFields) {
      var hasErrors = false;
      var validField;
      var response;

      for (const field of Object.keys(formFields)) {
        if (formFields[field].show !== false)
          if (formFields[field].type == "group") {
            response = this.validateForm(formFields[field].fields);
            if (!response) {
              hasErrors = true;
            }
          } else if (formFields[field].type == "variants") {
            response = true;
            formFields[field].value.forEach((variant) => {
              response = this.validateForm({ ...variant.fields });
              if (!response) {
                hasErrors = true;
              }
            });
          } else {
            validField = this.validateData(formFields[field]);
            if (!validField) {
              console.log(`Invalid field - ${field}`);
              formFields[field].hasError = true;
              hasErrors = true;
            } else {
              formFields[field].hasError = false;
            }
          }
      }
      return !hasErrors;
    },

    // Data validation
    validateData(field) {
      switch (field.type) {
        case "text":
        case "textarea":
        case "text-editor":
        case "date":
        case "password":
        case "profile-image":
        case "slug-url":
          if (
            field.required &&
            (field.value == undefined || field.value.length == 0)
          )
            return false;
          else return true;

        case "number":
        case "money":
          if (
            field.required &&
            (field.value == undefined ||
              field.value.length == 0 ||
              isNaN(field.value))
          )
            return false;
          else return true;

        case "tel":
          if (
            field.required &&
            (field.value == undefined || field.value.length != 10)
          )
            return false;
          else return true;

        case "country-tel":
          if (field.required && field.value.number == undefined) return false;
          else return true;

        case "url":
          if (
            field.required &&
            (field.value == undefined || field.value.length == 0)
          )
            return false;
          else if (
            !field.required &&
            field.value != undefined &&
            field.value != null &&
            field.value != "" &&
            field.value.length > 0
          ) {
            var pattern = new RegExp(
              "^(https?:\\/\\/)?" +
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
                "((\\d{1,3}\\.){3}\\d{1,3}))" +
                "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
                "(\\?[;&a-z\\d%_.~+=-]*)?" +
                "(\\#[-a-z\\d_]*)?$",
              "i"
            );
            return !!pattern.test(field.value);
          } else return true;

        case "toggle":
        case "checkbox":
          return true;

        case "radio":
          if (
            field.required &&
            (field.modelName == undefined || field.modelName.length == 0)
          )
            return false;
          else return true;

        case "file-large":
        case "gallery-images":
          if (
            field.required &&
            (field.fileList == undefined || field.fileList.length == 0)
          )
            return false;
          else return true;

        case "dropdown":
          if (field.required && !field.value.length) return false;
          else return true;

        case "multiple-select-dropdown":
          if (field.required && field.selectedItems.length == 0) return false;
          else return true;

        case "email":
          if (
            field.required &&
            (field.value == undefined || field.value.length == 0)
          )
            return false;
          else if (
            !field.required &&
            (field.value == undefined || field.value.length == 0)
          ) {
            return true;
          } else {
            var emailValidator = /^\w+[\w-+.]*@\w+([-.]\w+)*\.[a-zA-Z]{2,}$/;
            return field.value.match(emailValidator);
          }
        case "time":
          if (field.required && (field.value == "" || field.value === null))
            return false;
          else return true;
        case "scheduler":
          var ele = this;
          var hasError = false;
          // Parse through the days
          field.days.forEach(function (day) {
            if (day.isActive.value)
              day.timeSlots.forEach(function (timeSlot) {
                if (!ele.validateForm(timeSlot)) hasError = true;
              });
          });
          return !hasError;
      }
    },

    // Create JSON object for data transfer
    parseData(formFields, allowEmptyValues = false) {
      var parsedData = {};
      var tempData;

      //Loop through all the fields
      for (const field of Object.keys(formFields)) {
        if (formFields[field] != null && formFields[field].show !== false) {
          //Check if it's a group of fields
          if (formFields[field].type == "group") {
            var groupFields = formFields[field].fields;
            tempData = this.parseData(groupFields);

            //Add the fields in a nested object
            if (
              formFields[field].nestFields == true &&
              Object.keys(tempData).length !== 0
            ) {
              parsedData[field] = tempData;
            } else {
              parsedData = { ...parsedData, ...tempData };
            }
          }
          //Check if it's a variants type
          else if (formFields[field].type == "variants") {
            var variantFields = formFields[field].value;

            let variantsArray = [];
            variantFields.forEach((variant) => {
              variantsArray.push({
                _id: variant.variantID,
                ...this.parseData({ ...variant.fields }),
              });
            });
            tempData = variantsArray;

            //Add the fields in a nested object
            if (
              formFields[field].nestFields == true &&
              Object.keys(tempData).length !== 0
            ) {
              parsedData[field] = tempData;
            } else {
              parsedData = { ...parsedData };
              parsedData[field] = tempData;
            }
          }
          //If it's a multiple select dropdown
          else if (
            formFields[field].type == "multiple-select-dropdown" &&
            formFields[field].selectedItems.length != 0
          ) {
            parsedData[field] = formFields[field].selectedItems;
          }

          //If it's a multiple select dropdown
          else if (
            formFields[field].type == "dropdown" &&
            formFields[field].value != "" &&
            formFields[field].value.length !== 0
          ) {
            parsedData[field] = formFields[field].value[1];
          }

          //If it's a multiple toggle button
          else if (
            formFields[field].type == "radio" &&
            formFields[field].value != undefined
          ) {
            const object = formFields[field].options.find(
              (o) => o.name === formFields[field].value
            );
            parsedData[field] = object.value;
          }

          //If it's a multiple toggle button
          else if (formFields[field].type == "gallery-images") {
            if (formFields[field].fileList.length)
              parsedData.uploadedFiles = formFields[field].fileList;
            if (formFields[field].value.length)
              parsedData[field] = formFields[field].value;
          }

          //If it's a scheduler type
          else if (formFields[field].type == "scheduler") {
            var days = [],
              timeSlots = [];
            var slotsLength;

            const ele = this;
            formFields[field].days.forEach(function (day) {
              slotsLength = day.timeSlots.length;
              if (day.isActive.value) {
                timeSlots = [];
                for (let i = 0; i < slotsLength; i++) {
                  timeSlots.push(ele.parseData(day.timeSlots[i]));
                }
              }

              days.push({
                day: day.day.substring(0, 3),
                isActive: day.isActive.value,
                timeSlots: day.isActive.value ? timeSlots : [],
              });
            });
            parsedData[field] = days;
          }

          //If it's a phone type
          else if (formFields[field].type == "country-tel") {
            if (
              formFields[field]?.dataNumberOnly &&
              formFields[field]?.value?.number
            ) {
              parsedData[field] =
                "+" +
                formFields[field]?.value.countryCallingCode +
                formFields[field]?.value?.number;
            } else if (formFields[field]?.value?.number)
              parsedData[field] = formFields[field].value;
          }

          //If it's a money type
          else if (formFields[field].type == "money") {
            if (parseInt(formFields[field].value)) {
              parsedData[field] = parseInt(formFields[field].value);
            }
          }

          //Add field if it's a normal field
          else if (
            formFields[field].value !== undefined &&
            formFields[field].value !== null &&
            (allowEmptyValues || formFields[field].value !== "") &&
            (allowEmptyValues || formFields[field].value.length !== 0)
          ) {
            parsedData[field] = formFields[field].value;
          }
        }
      }

      return parsedData;
    },

    // Reset form
    resetFields(formFields) {
      for (const field of Object.keys(formFields)) {
        if (formFields[field].type == "group")
          this.resetFields(formFields[field].fields);
        else if (
          formFields[field].type == "file-large" ||
          formFields[field].type == "gallery-images"
        ) {
          formFields[field].fileList.splice(0);
          formFields[field].imagesList.splice(0);
          formFields[field].value.splice(0);
        } else if (formFields[field].type == "country-tel") {
          formFields[field].value = {
            countryCode: null,
            countryCallingCode: null,
            number: null,
          };
        } else if (formFields[field].type == "variants") {
          formFields[field].value = [];
        } else {
          formFields[field].value = "";
        }
      }
    },

    /****************************/
    /** Form Validations **/
    /****************************/

    // Get the currency symbols against the names
    getCurrency(currency) {
      var currencySymbols = {
        USD: "$", // US Dollar
        CAD: "$", // Canadian Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
      };

      if (currencySymbols[currency] !== undefined)
        return currencySymbols[currency];
      else return currency;
    },

    getPhoneNumberString(phone) {
      return `+${phone.countryCallingCode}${phone.number}`;
    },

    hexToHSL(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(result[1], 16);
      let g = parseInt(result[2], 16);
      let b = parseInt(result[3], 16);

      (r /= 255), (g /= 255), (b /= 255);
      let max = Math.max(r, g, b),
        min = Math.min(r, g, b);
      let h,
        s,
        l = (max + min) / 2;

      if (max == min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      h = Math.round(h * 360);
      s = Math.round(s * 100);
      l = Math.round(l * 100);

      return { h, s, l };
    },
  },
};
